import { SingleActionConfig } from "./SingleActionConfig";
import { Action, DatabaseAction } from "../Action";
import { getTeamShortName } from "../../../utils/getTeamShortName";

export class DynamicPossessionActionConfig extends SingleActionConfig {
  constructor(
    action: Action,
    databaseActionConfig: SingleActionConfig,
    phrase: string,
    isHomeTeamPossession: boolean
  ) {
    if (!(databaseActionConfig.action in DatabaseAction)) {
      console.error("The databaseActionConfig action must be of type DatabaseAction.");
      return;
    }
    super(
      action,
      databaseActionConfig.nextActions,
      databaseActionConfig.getRequiresPitchClick,
      databaseActionConfig.possessionChange,
      databaseActionConfig.action as DatabaseAction
    );

    this.getClickPhrase = () => phrase;
    this.getButtonPhrase = (_, homeTeam, awayTeam) =>
      `${getTeamShortName((isHomeTeamPossession ? homeTeam : awayTeam).name)} ${phrase}`;
    this.getIsHomeTeamPossession = () => isHomeTeamPossession;
  }
}
